import { Pipe, PipeTransform } from '@angular/core';
import { Utils } from '../../utils/utils';

/**
 * Nome da mostrare per un lead, con il placeholder al posto dell'anagrafica non più disponibile.
 * Delega a {@link Utils.formatLeadName}, così template e codice TypeScript dicono la stessa cosa.
 *
 * Uso: `{{ contactRequest.lead | leadName }}`.
 */
@Pipe({ name: 'leadName', standalone: true })
export class LeadNamePipe implements PipeTransform {
  transform(lead?: { firstname?: string | null; lastname?: string | null } | null): string {
    return Utils.formatLeadName(lead);
  }
}
